import { TranslateResources } from './translateCodes';

const translation: Partial<TranslateResources> = {
    MINS: 'mins',
    YOUR_EMAIL: 'Your Email',
    PHONE: 'Phone number',
    CONTINUE: 'Continue',
    TRANSACTION_DETAILS: 'Transaction Details',
    CLIENT_NAME: 'Client name',
    PHONE_NUMBER: 'Phone number',
    PAYMENT_TYPE: 'Payment type',
    SALE_ID: 'Sale ID',
    DESCRIPTION: 'Description',
    PRICE: 'Price',
    SERVICE: 'Service',
    PRODUCT: 'Product',
    SUB_TOTAL: 'Sub total',
    DISCOUNT: 'Discount',
    TAX: 'Tax',
    TIP: 'Tip',
    TOTAL_AMOUNT: 'Total amount',
    RATE_EXPERIENCE: 'Please rate your experience with',
    GIVE_FEEDBACK: 'Give feedback',
    ENTER_FEEDBACK: 'Enter your feedback',
    SUBMIT: 'Submit',
    VIEW_TRANSACTION_DETAILS: 'View transaction details',
    WE_LOVE_FEEDBACK: 'We’d love your feedback!',
    SHARE_EXPERIENCE_GOOGLE: 'Share your experience with us on Google and help others discover our services.',
    CLICK_TO_REVIEW: 'Click to review!',
    REVIEW_EXISTS: 'Review is existed',
    SALE_REVIEWED: 'The sale is reviewed',
    THANK_FOR_FEEDBACK: 'Thank you for sharing your feedback!',
    FEEDBACK_RECEIVED: 'We’ve received your input and truly value your contribution to helping us improve.',
};

export const en = {
    translation,
};
